export default {"src":"/_next/static/media/trainers.6c9e4283.svg","height":15,"width":13,"blurWidth":0,"blurHeight":0};